// extracted by mini-css-extract-plugin
export default {"root":"LeaseDetails_root__4EZls","item":"LeaseDetails_item__vgmRn","label":"LeaseDetails_label__S3LTY","infoIcon":"LeaseDetails_infoIcon__hUh1m","value":"LeaseDetails_value__bnq4Z"};